var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Instance',{attrs:{"instance":"shiftPositions","instance-name":"Shift Positions","create":d => _vm.shiftPositions.create(d),"delete":d => _vm.shiftPositions.remove(d),"update":d => _vm.shiftPositions.update(d),"get":d => _vm.shiftPositions.get(d),"upsert":_vm.upsert,"columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }